// extracted by mini-css-extract-plugin
module.exports = {"button":"MainNavButton-module--button--BP0up","invert":"MainNavButton-module--invert--1bjdg","text":"MainNavButton-module--text--1eOEa","icon":"MainNavButton-module--icon--3U6dG"};